import { Injectable } from "@angular/core";
import { Http, Headers, RequestOptions, Response } from "@angular/http";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import "rxjs/add/operator/map";

import { AuthenticationService } from "./index";
import { User } from "../_models/index";

import { EnvironmentService } from "./index";

@Injectable()
export class UserService {
  private baseUrl: string = this.environmentService.getBaseURL() + "/api";
  private isadmin: boolean;
  private token: string;
  private dealerid: string;
  private fullname: string;
  private _id: string;

  constructor(
    private http: Http,
    private authenticationService: AuthenticationService,
    private environmentService: EnvironmentService
  ) {
    var currentUser = JSON.parse(localStorage.getItem("currentUser"));
    this.token = currentUser && currentUser.token;
    this.dealerid = currentUser && currentUser.dealerid;
    this.isadmin = currentUser && currentUser.isadmin;
    this.fullname = currentUser && currentUser.fullname;
    this._id = currentUser && currentUser._id;
  }

  logout() {
    // reset login status
    this.authenticationService.logout();
    window.location.reload();
  }

  getIsadmin(): boolean {
    return this.isadmin;
  }

  getId(): string {
    return this._id;
  }

  getDealerId(): string {
    return this.dealerid;
  }

  getFullname(): string {
    return this.fullname;
  }

  getUsers(): Observable<User[]> {
    // add authorization header with jwt token
    let headers = new Headers({
      Authorization: "Bearer " + this.authenticationService.token,
    });
    let options = new RequestOptions({ headers: headers });

    // get users from api
    return this.http
      .get("/api/users", options)
      .map((response: Response) => response.json());
  }
  update(user: User): Observable<Response> {
    return this.http.put(
      `${this.baseUrl}/users/${user._id}`,
      JSON.stringify(user),
      this.makeHeaders()
    );
  }
  private makeHeaders(): RequestOptions {
    let headers = new Headers();

    headers.append("Authorization", this.authenticationService.getToken());
    headers.append("Content-Type", "application/json ");
    headers.append("charset", "UTF-8 ");
    headers.append("Accept", "application/json ");

    let options = new RequestOptions({ headers: headers });
    return options;
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/user.service.ts